import { createSlice } from "@reduxjs/toolkit";

export const kbArticleSlice = createSlice({
  name: "kbArticle",
  initialState: {
    getKbArticleResult: false,
    getKbArticleLoading: false,
    getKbArticleError: false,
    addKbArticleResult: false,
    addKbArticleLoading: false,
    deleteKbArticleResult: false,
  },
  reducers: {
    kbArticleReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_KBARTICLE":
          return {
            ...state,
            getKbArticleResult: payload.data,
            getKbArticleLoading: payload.loading,
            getKbArticleError: payload.error,
          };
        case "ADD_KBARTICLE":
          return {
            ...state,
            addKbArticleResult: payload.data,
            addKbArticleLoading: payload.loading,
          };
        case "DELETE_KBARTICLE":
          return {
            ...state,
            deleteKbArticleResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { kbArticleReducers } = kbArticleSlice.actions;

export default kbArticleSlice.reducer;
